<template>
	<div v-show="!empty" class="m-operate flex-between-center" :empty="empty" :border="border">
		<div v-if="batch" key="batch" class="m-operate-group flex-center-cross">
			<p class="batch-count">已选 {{batch}} 条</p>
			<c-button prepend-icon="tf-revoke" @click="$emit('batchCancel')">取消选择</c-button>
			<slot name="batch"></slot>
		</div>
		<div v-else key="normal" class="m-operate-group flex-center-cross">
			<slot></slot>
		</div>
		<div class="m-operate-group flex-center-cross">
			<slot name="right"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'mOperate',

		props: {
			border: Boolean,
			batch: Number
		},

		data() {
			return {
				empty: true
			}
		},

		mounted() {
			this.empty = !this.$children.length;
		},

		updated() {
			this.empty = !this.$children.length;
		}
	}
</script>

<style lang="stylus" scoped>
	.m-operate {
		border: 1px solid var(--table-border);
		border-width: 1px 0 0;
		padding: 6px 12px;
		background: #FAFAFA;

		&[border] {
			border-width: 1px 1px 0;
		}

		&-group {
			gap: 8px;
		}

		.batch-count {
			font-size: 13px;
			color: #333;
		}
	}
</style>
